<app-spinner-overlay></app-spinner-overlay>

<app-lista-tabellare
  #tabella
  [fnCaricamentoDati]="fnCaricamentoDati"
  [colonne]="colonne"
  [filtri]="filtri"
  (bottoniListaClick)="bottoniListaClick($event)"
>
  <div btnStart>
    <button
      mat-flat-button
      color="accent"
      class="accent-button"
      (click)="apriAttivazioni()"
      *ngIf="!id_azienda && this.utenteService.isPermessoAttivo('READ_CONFIGURAZIONI')"
    >
      <mat-icon>event_available</mat-icon>
      Attivazioni
    </button>
  </div>
  <div btnEnd>
    <button
      mat-flat-button
      color="primary"
      class="primary-button"
      (click)="crea()"
      *ngIf="this.utenteService.isPermessoAttivo('CREATE_UTENTI')"
    >
      Nuovo
    </button>
  </div>
</app-lista-tabellare>
